/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('EsignatureDetailsModal', ['$modal', '$translate', 'Esignature', 'flashMessagesService', 'Session',
        function ($modal, $translate, Esignature, flashMessagesService, Session) {
            return {
                open: function (esignature) {
                    const file = esignature.mainItem;

                    $modal.open({
                        domOptions: {
                            modalActionButton: $translate.instant('Close'),
                            modalBodyTemplate: 'modals/actions/sign_file/esignature_details',
                            modalNotifications: true,
                            modalSubTitle: $translate.instant('Revision') + ' ' + file.revision,
                            modalTitle: file.name,
                            modalType: 'notify',
                        },
                        controller: [
                            '$modalInstance',
                            '$scope',
                            function ($modalInstance, $scope) {
                                $scope.modal = $modalInstance.options;
                                $scope.esignature = esignature;
                                $scope.file = file;
                                $scope.close = $scope.ok = $modalInstance.dismiss;

                                if (!esignature.isNotarized) {
                                    Esignature.getDocument({
                                        node_uuid: esignature.node_uuid,
                                        action: esignature.uuid
                                    }).$promise.then(e => $scope.esignature = esignature = e);
                                }

                                $scope.canResend = function (signee) {
                                    return signee.permissions.can_resend_invitation && (!esignature.isSequentialSignature || !signee.is_owner);
                                }

                                $scope.canSign = function (signee) {
                                    return (
                                        esignature.isSequentialSignature &&
                                        esignature.isDueSignee(signee) &&
                                        signee.is_owner &&
                                        signee.email === Session.account.email
                                    );
                                }

                                $scope.resend = function (signee) {
                                    if (signee.isResendInProgress === true) {
                                        return;
                                    }

                                    signee.isResendInProgress = true;

                                    Esignature.resend({
                                        uuid: esignature.uuid,
                                        node_uuid: esignature.node_uuid,
                                        signee_id: signee.uuid
                                    }).$promise
                                        .then(() => flashMessagesService.add(
                                            $translate.instant(
                                                'esignature_details_dialog_resend_success_message',
                                                {
                                                    file_name: file.name,
                                                    signee_email: signee.email,
                                                }
                                            ),
                                            flashMessagesService.SUCCESS,
                                            null,
                                            true
                                        ))
                                        .finally(function () {
                                            signee.isResendInProgress = false;
                                        });
                                };
                            }
                        ],
                        windowClass: 'esignature-details',
                        backdrop: 'static',
                        keyboard: false
                    });
                }
            }
        }]);
